import { OrganizationSwitcher, UserButton } from "@clerk/clerk-react";

/** Clerk org switcher + user menu, shown in the topbar when Clerk is enabled. */
export function AuthControls() {
  return (
    <div className="flex shrink-0 items-center gap-2 [&_.cl-organizationPreviewTextContainer]:sr-only sm:[&_.cl-organizationPreviewTextContainer]:not-sr-only">
      <OrganizationSwitcher
        hidePersonal
        afterSelectOrganizationUrl="/"
        afterCreateOrganizationUrl="/"
        appearance={{ elements: { rootBox: "flex items-center" } }}
      />
      <UserButton afterSignOutUrl="/" />
    </div>
  );
}
